import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { user, token } = action.payload;
      localStorage.setItem(
        "user",
        JSON.stringify({
          user,
          token,
        })
      );
      state.user = user;
      state.token = token;
    },
    logout: (state, action) => {
      localStorage.clear();
      state.user = null;
      state.token = null;
    },
  },
});

export const selectAuth = (state) => state.auth;

export const { setUser, logout } = authSlice.actions;

export default authSlice.reducer;
